// Fetch list

export const FETCH = 'reportVehicleTraffic.FETCH'
export const FETCH_STARTED = 'reportVehicleTraffic.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportVehicleTraffic.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportVehicleTraffic.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportVehicleTraffic.FETCH_CANCELLED'

// Clear

export const CLEAR = 'reportVehicleTraffic.CLEAR'

// Export

export const EXPORT = 'reportVehicleTraffic.EXPORT'
export const EXPORT_FULFILLED = 'reportVehicleTraffic.EXPORT_FULFILLED'

// Fetch details

export const FETCH_DETAILS = 'reportVehicleTraffic.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportVehicleTraffic.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportVehicleTraffic.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportVehicleTraffic.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportVehicleTraffic.FETCH_DETAILS_CANCELLED'

// Clear details

export const CLEAR_DETAILS = 'reportVehicleTraffic.CLEAR_DETAILS'

// Export details

export const EXPORT_DETAILS = 'reportVehicleTraffic.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportVehicleTraffic.EXPORT_DETAILS_FULFILLED'
